import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = { class: "custom-modal-overlay" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title",
  id: "moreuserModalLabel"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = { class: "scrollable-member-list" }
const _hoisted_10 = { class: "round-img" }
const _hoisted_11 = {
  key: 0,
  class: "text-lowercase"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "tooltip-content"
}
const _hoisted_18 = { class: "channel-name" }
const _hoisted_19 = { class: "channel-detail" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Never Expire ")
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_25 = { class: "channel-detail" }
const _hoisted_26 = /*#__PURE__*/_createVNode("strong", null, "Conversation History From:", -1)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" ( ")
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" }, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "tooltip-content"
}
const _hoisted_38 = { class: "channel-name" }
const _hoisted_39 = { class: "channel-detail" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Never Expire ")
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_45 = { class: "channel-detail" }
const _hoisted_46 = /*#__PURE__*/_createVNode("strong", null, "Conversation History From:", -1)
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('all_members')), 1),
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [
              _hoisted_7
            ])
          ]),
          (_ctx.members && _ctx.members.length)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.members, (member, memberIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "member-list pr-0",
                      key: memberIndex
                    }, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("img", {
                          src: member.image || (_ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg` : 'img/no-user.jpg'),
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      (_ctx.projectRoleCodes.some((role) => ['owner', 'co-owner'].includes(role)) 
               && (member.email || member.mobile_number) 
               && !(member.full_name || (member.first_name || member.last_name)))
                        ? (_openBlock(), _createBlock("p", _hoisted_11, [
                            (member.email && member.mobile_number)
                              ? (_openBlock(), _createBlock("span", _hoisted_12, [
                                  (member.email === member.mobile_number)
                                    ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(member.email), 1))
                                    : (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.displayEmailOrPhone(member.email)) + " / " + _toDisplayString(member.mobile_number), 1))
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.displayEmailOrPhone(member.email) || member.mobile_number), 1)),
                            _createVNode("span", {
                              class: "tooltip-icon",
                              onMouseenter: ($event: any) => (_ctx.showTooltip = memberIndex),
                              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = null))
                            }, [
                              _hoisted_16,
                              (_ctx.showTooltip === memberIndex)
                                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                    (member.channels?.length)
                                      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(member.channels, (channel, cIndex) => {
                                          return (_openBlock(), _createBlock("div", {
                                            key: cIndex,
                                            class: "channel-entry"
                                          }, [
                                            _createVNode("p", _hoisted_18, [
                                              _createVNode("strong", null, _toDisplayString(channel.name), 1)
                                            ]),
                                            _createVNode("p", _hoisted_19, [
                                              (channel.invitation?.completed_date && channel.invitation?.validity === 0)
                                                ? (_openBlock(), _createBlock("span", _hoisted_20, [
                                                    _hoisted_21,
                                                    _hoisted_22
                                                  ]))
                                                : (channel.invitation?.completed_date && channel.invitation?.validity)
                                                  ? (_openBlock(), _createBlock("span", _hoisted_23, [
                                                      _hoisted_24,
                                                      _createTextVNode(" " + _toDisplayString(_ctx.calculateValidTill(channel.invitation.completed_date, channel.invitation.validity)), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                            ]),
                                            _createVNode("p", _hoisted_25, [
                                              _createVNode("span", null, [
                                                _hoisted_26,
                                                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(channel.invitation?.message_from_date) || 'N/A'), 1)
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      : (_openBlock(), _createBlock("p", _hoisted_27, "No active channels"))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 40, ["onMouseenter"])
                          ]))
                        : (member.full_name || (member.first_name || member.last_name))
                          ? (_openBlock(), _createBlock("p", _hoisted_28, [
                              _createTextVNode(_toDisplayString(member.full_name || [member.first_name, member.last_name].filter(Boolean).join(' ')), 1),
                              (_ctx.projectRoleCodes.some((role) => ['owner', 'co-owner'].includes(role)) && (member.email || member.mobile_number))
                                ? (_openBlock(), _createBlock("span", _hoisted_29, [
                                    _hoisted_30,
                                    (member.email && member.mobile_number)
                                      ? (_openBlock(), _createBlock("span", _hoisted_31, [
                                          (member.email === member.mobile_number)
                                            ? (_openBlock(), _createBlock("span", _hoisted_32, _toDisplayString(member.email), 1))
                                            : (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.displayEmailOrPhone(member.email)) + " / " + _toDisplayString(member.mobile_number), 1))
                                        ]))
                                      : (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(_ctx.displayEmailOrPhone(member.email) || member.mobile_number), 1)),
                                    _hoisted_35
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("span", {
                                class: "tooltip-icon",
                                onMouseenter: ($event: any) => (_ctx.showTooltip = memberIndex),
                                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTooltip = null))
                              }, [
                                _hoisted_36,
                                (_ctx.showTooltip === memberIndex)
                                  ? (_openBlock(), _createBlock("div", _hoisted_37, [
                                      (member.channels?.length)
                                        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(member.channels, (channel, cIndex) => {
                                            return (_openBlock(), _createBlock("div", {
                                              key: cIndex,
                                              class: "channel-entry"
                                            }, [
                                              _createVNode("p", _hoisted_38, [
                                                _createVNode("strong", null, _toDisplayString(channel.name), 1)
                                              ]),
                                              _createVNode("p", _hoisted_39, [
                                                (channel.invitation?.completed_date && channel.invitation?.validity === 0)
                                                  ? (_openBlock(), _createBlock("span", _hoisted_40, [
                                                      _hoisted_41,
                                                      _hoisted_42
                                                    ]))
                                                  : (channel.invitation?.completed_date && channel.invitation?.validity)
                                                    ? (_openBlock(), _createBlock("span", _hoisted_43, [
                                                        _hoisted_44,
                                                        _createTextVNode(" " + _toDisplayString(_ctx.calculateValidTill(channel.invitation.completed_date, channel.invitation.validity)), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _createVNode("p", _hoisted_45, [
                                                _createVNode("span", null, [
                                                  _hoisted_46,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(channel.invitation?.message_from_date) || 'N/A'), 1)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        : (_openBlock(), _createBlock("p", _hoisted_47, "No active channels"))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 40, ["onMouseenter"])
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_48, "Unknown Member"))
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_49, [
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              "data-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, _toDisplayString(_ctx.$t('close')), 1)
          ])
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.state.data.showMemberListModal]
  ])
}